export default {
  isXeroLogin: null,
  validationStateCode: '',
  xeroOrigin: '',
  onboardingData: {
    isUserExists: null,
    xeroUserId: '',
    xeroConnectionStatus: null,
    claims: {
      nbf: '',
      exp: '',
      iss: '',
      aud: '',
      iat: '',
      at_hash: '',
      s_hash: '',
      sid: '',
      sub: '',
      auth_time: '',
      xero_userid: '',
      global_session_id: '',
      preferred_username: '',
      email: '',
      given_name: '',
      family_name: '',
      name: '',
      amr: ''
    }
  }
}
